/*globals ratingCategories:true reviewId:true reviewRequestId:true reviewType:true redirectionUrl:true siteId: true leadId: true*/

angular.module('b2cApp.controllers').controller('ReviewController', function ($scope, $filter, ProjectReview, $window, TranslationService, Budgets) {

    const AUTO_REVIEW = 'AUTO_REVIEW';
    const PROJECT_REVIEW = 'PROJECT_REVIEW';
    const EXTERNAL_REVIEW = 'EXTERNAL_REVIEW';

    $scope.ratingAverage = {
        value: null,
        state: ''
    };

    $scope.titleExperienceLength = {min: 5, max: 50};
    $scope.experienceLength = {min: 20, max: 1000};
    $scope.reviewType = reviewType;
    // Similar code in the 2 functions - merging them into only 1 would increase complexity for marginal benefit
    $scope.updateInputTitleExperienceCountdown = function (event) {
        $scope.reviewSubmitted = false;
        $scope.titleExperienceCount = TranslationService.trans('review.characters_left', {charactersLeft: $scope.titleExperienceLength.max - event.target.value.length}, 'submit_review');
    };
    $scope.updateInputExperienceCountdown = function (event) {
        $scope.reviewSubmitted = false;
        $scope.experienceCount = TranslationService.trans('review.characters_left', {charactersLeft: $scope.experienceLength.max - event.target.value.length}, 'submit_review');
    };

    $scope.budgetOptions = [];
    $scope.projectBudget = {
        option: null
    };

    $scope.ratings = [];

    for (var i = 0; i < ratingCategories.length; i++) {
        $scope.ratings.push({
            name: TranslationService.trans('rating_category.' + ratingCategories[i].name, [], 'submit_review'),
            ratingCategoryId: ratingCategories[i].id,
            value: null,
            state: ''
        });
    }

    $scope.getBudgets = function () {
        $scope.budgets = Budgets.query({siteId: siteId}).$promise.then(
            function (data) {
                data.forEach(function (option) {
                    var min = $filter('currency')(option.minimum, undefined, 0);
                    var max = $filter('currency')(option.maximum, undefined, 0);
                    $scope.budgetOptions.push({
                        min: min,
                        max: max,
                        text: option.maximum ? min + ' - ' + max : min + '+',
                        textRaw: option.maximum ? min + ' - ' + max : min + '+'
                    });
                });
                $scope.budgetOptions.push({
                    text: TranslationService.trans('budget_value_unknown', [], 'submit_review'),
                    textRaw: 'budget_value_unknown'
                });
            }
        );
    };

    $scope.updateAverage = function () {
        var isReady = !$scope.ratings.some(function (rating) {
            return (rating.value == null || rating.value === 0);
        })

        if (isReady) {
            var totalScore = $scope.ratings.reduce(function (accumulator, rating) {
                return accumulator + rating.value;
            }, 0);
            var value = (totalScore / $scope.ratings.length);

            $scope.ratingAverage.value = value * 2;
            $scope.ratingAverage.state = $scope.getRatingState(value);
        } else {
            $scope.ratingAverage.value = null;
            $scope.ratingAverage.state = $scope.getRatingState(0);
        }
    };

    $scope.updateState = function (rating, value) {
        rating.state = $scope.getRatingState(value);
    };

    /**
     * todo: extract the function to one place and reuse everywhere
     * When changing the ratings here, you probably also have to adjust them in the following files:
     *  - angular/projects/self-service/src/app/projects/review/block/rating-label.component.ts: getRatingColorClass
     *  - symfony-standard/src/SD/B2bLoginBundle/Resources/public/app_b2b_login/company_profile_controller/js/company-profile-controller.js
     *  - angular/projects/self-service/src/app/projects/review/category-score-rating/category-score-rating.component.ts: getRatingClass
     */
    $scope.getRatingState = function (value) {
        if (null === value || value === 0) {
            return '';
        }
        if (value <= 1.3) {
            return 'rating-bad';
        }
        if (value <= 2.8) {
            return 'rating-poor';
        }
        if (value <= 3) {
            return 'rating-fair';
        }
        if (value <= 4) {
            return 'rating-good';
        }
        if (value <= 5) {
            return 'rating-excellent';
        }
    };

    $scope.getRatingTranslation = function (ratingState) {
        return ratingState ?
            TranslationService.trans('rating_state.' + ratingState.replace(/-/g, '_'), [], 'submit_review') : '';
    };

    $scope.getRequestUrl = function () {
        switch($scope.reviewType) {
            case PROJECT_REVIEW:
                return '/rest/v2/review-requests/' + reviewRequestId;
            case AUTO_REVIEW:
                return '/rest/v2/automatic-review-requests/' + reviewRequestId;
            case EXTERNAL_REVIEW:
                return '/rest/v2/external-review-requests/' + reviewRequestId;
        }
    };

    $scope.submitForm = function (isValid) {

        $scope.reviewSubmitted = true;

        if (isValid) {
            $scope.disableSubmit = true;
            var projectReview = new ProjectReview({
                leadId: leadId,
                reviewId: reviewId,
                title: $scope.titleExperience,
                description: $scope.experience,
                ratings: $scope.ratings,
                request: $scope.getRequestUrl(),
                phoneNumber: $scope.phoneNumber,
                externalReview: $scope.reviewType === EXTERNAL_REVIEW,
                categoryId: siteId,
                budget: $scope.projectBudget.option
            });
            projectReview.$save().then(function (response) {
                if (response.status !== 200) {
                    $scope.invalidFormReason = response.message;
                    $window.scrollTo(0, 0);
                    $scope.disableSubmit = false;
                } else {
                    if (response.rating) {
                        const presentationRating = response.rating * 2;
                        const redirectionUrlObj = new URL(redirectionUrl);
                        redirectionUrlObj.searchParams.append('utm_campaign', 'trustpilot');
                        redirectionUrlObj.searchParams.append('utm_source', 'review');
                        redirectionUrlObj.searchParams.append('rating', presentationRating >= 7 ? 'positive' : 'negative');
                        redirectionUrl = redirectionUrlObj.toString();
                    }
                    $window.location.href = redirectionUrl;
                }
            });
        } else {
            // Get the Y value of the first input with an error and scroll there
            for (var error in $scope.review.$error) {
                var top = document.getElementsByName($scope.review.$error[error][0].$name)[0].offsetTop;
                window.scrollTo(0, top);
            }
        }
    };

    $scope.getBudgets();
});
